export default {"src":"/_next/static/media/applServices.824bdb1e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};